/* eslint-disable */
import SimpleSelectDropdown from './SimpleSelectDropdown'

export default SimpleSelectDropdown
